<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 20 20">
      <path 
        fill-rule="evenodd" 
        d="M9.99984 1.66602C5.39984 1.66602 1.6665 5.39935 1.6665 9.99935C1.6665 14.5993 5.39984 18.3327 9.99984 18.3327C14.5998 18.3327 18.3332 14.5993 18.3332 9.99935C18.3332 5.39935 14.5998 1.66602 9.99984 1.66602ZM3.33317 9.99935C3.33317 13.6743 6.32484 16.666 9.99984 16.666C13.6748 16.666 16.6665 13.6743 16.6665 9.99935C16.6665 6.32435 13.6748 3.33268 9.99984 3.33268C6.32484 3.33268 3.33317 6.32435 3.33317 9.99935ZM5.83317 9.16602V10.8327H14.1665V9.16602H5.83317Z" 
        clip-rule="evenodd"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: "KickMeeting",
  props: {
    title: {
      type: String,
      default: ""
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/KickMeeting.vue